<template>
    <div class="page-wrapper">
        <div class="cg-crumb">
            <btn-back />
            <span class="item">商城</span>
            <em class="gap">/</em>
            <span class="item">商品详情</span>
        </div>
        <div class="detailPanel">
            <div class="leftArea">
                <div class="mainImgBox">
                    <el-image class="img" :src="goodsImage" fit="contain" :preview-src-list="goodsImageList"></el-image>
                </div>
            </div>
            <div class="rightArea">
                <div class="title">{{detail.itemName}}</div>
                <div class="normalLine firstLine">
                    <div class="left oneFlex">类目：{{detail.productCategory}}</div>
                    <div class="left oneFlex">商品款号：{{detail.styleNumber}}</div>
                </div>
                <div class="normalLine secondLine">
                    <!-- <div class="left oneFlex">供应商：{{detail.supplierName}}</div> -->
                    <div class="left oneFlex">品牌：{{detail.brand}}</div>          
                    <div class="left oneFlex">商品Id：{{detail.item_id}}</div>
                </div>

                <div class="redArea">
                    <div class="priceLine" style="margin-right: 25px;">
                        销售价： <span class="num">¥{{detail.price | price}} <i class="danwei">元</i> </span> 
                    </div>
                    <div class="fenyong">
                        分佣比例 销售商 : 供应商={{detail.dealerPercent}}% : {{detail.supplierPercent}}%
                        <span class="minFont">说明：如1000元的单件，一件您的分利润为{{1000*detail.dealerPercent/100}}元，您需要支付平台{{1000*detail.supplierPercent/100}}元</span>
                    </div>
                </div>

                <div class="line" style="font-size: 16px;">
                    <img src="../../../assets/xiangqingpage_icon-shopcar.png" alt="" class="icon"> 可售总库存：<span class="yellow">{{detail.totalStock}}</span>
                    件
                </div>
                <div class="buttonLine">
                    <button class="cg-btn red red-border leftBtn" @click="toLock">锁仓</button>
                    <button class="cg-btn red " @click="toTakeOrder()">下单</button>
                </div>
                <hr class="fenge">
                <div class="oneSizeArr" v-for="(colorList,index) in sizeColorArr" :key="index">
                    <!-- {{colorList}} -->
                    <div class="line">
                        <span class="mylabel">颜色</span>
                        <div class="smallBtn"> {{colorList.color}}</div>
                    </div>
                    <div class="line">
                        <span class="mylabel">数量</span>
                        <span>可售库存{{colorList.count}}件</span>
                    </div>
                    <div class="sizeBox">
                        <div class="sizeLine" v-for="(sizeList,index) in colorList.sizeArr" :key="index">
                            <div class="size">{{sizeList.name}}</div>
                            <div class="sizeNum">{{sizeList.number}}件</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panelBox">
            <div class="panelTitle">面料信息</div>
            <div class="panelContent">
                <div class="oneItem">
                    <span class="myLabel">主面料名称 </span>
                    <span class="text">{{fabricAndAccessory.fabricName}}</span>
                </div>
                <div class="oneItem">
                    <span class="myLabel">主面料成分 </span>
                    <span class="text">{{fabricAndAccessory.fabricIngredient}}</span>
                </div>
                <div class="oneItem">
                    <span class="myLabel">填充物 </span>
                    <span class="text">{{fabricAndAccessory.fabricStuffing}}</span>
                </div>
            </div>
            <div class="panelTitle">图文详情</div>
            <div class="rich-text-wrap panelContent" v-html="detail.productContent"></div>
        </div>
        <!-- 锁仓弹出框 -->
        <el-dialog :visible.sync="isShowLockList" width="70%">
            <div class="modalContentWrap">
                <div class="pinkBlock" style="text-align: left;">
                    <div class="title">
                        <span class="span" style="margin-right: 25px;">定价：¥{{detail.price | price}}元</span> <span class="span">分佣比例
                        </span> <span class="span">销售商 : 供应商={{detail.dealerPercent}}% : {{detail.supplierPercent}}%</span>
                    </div>
                    <div class="subTitle"> 发起锁仓后需要供应商确认，供应商确认后，48小时内您必须发起下单，且调货比例必须大于锁仓数量的10%</div>
                </div>
                <div class="panelBox">
                    <div class="panelContent">
                        <div class="sizeControlBlock" v-for="(colorSizeList,index) in sizeColorArr_lock" :key="index">
                            <div class="sizeControl">
                                <div class="left">
                                    颜色:{{colorSizeList.color}}
                                    选择:{{colorSizeList.colorChoseTotal}} 件
                                </div>
                                <div class="right">现有库存:{{colorSizeList.colorStockTotal}} 件</div>
                            </div>
                            <div class="sizeContent">
                                <div class="sizeLine" v-for="(sizeList,index) in colorSizeList.sizeArr" :key="index">
                                    <span class="left">{{sizeList.name}}</span>
                                    <div class="middle">
                                        <el-input-number v-model="sizeList.sizelockNumber" size="small" :min="0" :max="sizeList.sizeStockTotal"
                                            @change="changeLockNumber"></el-input-number>
                                    </div>
                                    <span class="right">共{{sizeList.sizeStockTotal}}件</span>
                                </div>

                            </div>
                        </div>
                        <div class="bottomLine" style="text-align: left;">
                            <button class="cg-btn " style="width:75px ;margin-right: 40px;" @click="isShowLockList=false">取消</button>
                            <button class="cg-btn red" @click="submitLock">确定锁仓{{lockTotal}}件</button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 锁仓结果弹出框 -->
        <el-dialog :visible.sync="isShowLockSuccess" width="70%">
            <div class="modalContentWrap">
                <div class="pinkBlock">
                    <div class="title">成功发起锁仓 <span class="red">{{lockTotal}}</span> 件：</div>
                    <div class="subTitle">
                        <span class="span" style="margin-right: 25px;">销售定价：¥{{detail.price | price}}元/件</span>
                        <span class="span"> 分佣比例 </span>
                        <span class="span"> 销售商 : 供应商= {{detail.dealerPercent}}% : {{detail.supplierPercent}}%</span>
                    </div>
                </div>
                <div class="panelBox">
                    <div class="panelTitle">锁仓明细</div>
                    <div class="panelContent">
                        <div class="take-order-table">
                            <table class="table" >
                                <thead>
                                    <tr class="th">
                                        <th width="20%">颜色</th>
                                        <th width="20%">尺码</th>
                                        <th width="20%">锁仓数量</th>
                                        <th width="20%">锁仓小计</th>
                                        <th width="20%">库存总计</th>
                                    </tr>
                                </thead>               
                                <tbody >
                                    <tr v-for="(colorSizeList,index) in sizeColorArr_lock" :key="index">
                                        <td>{{colorSizeList.color}}</td>
                                        <td>
                                            <p v-for="(item2,index2) in colorSizeList.sizeArr" class="oneTdCol" :key="index2">
                                                {{item2.name}}
                                            </p>
                                        </td>
                                        <td>
                                            <p v-for="(item2,index2) in colorSizeList.sizeArr" class="oneTdCol" :key="index2">
                                                <span :class="{red:item2.sizelockNumber>0}">{{item2.sizelockNumber}}</span>
                                                
                                            </p>
                                        </td>
                                        <td>{{colorSizeList.colorChoseTotal}}</td>
                                        <td>{{colorSizeList.colorStockTotal}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                <div class="bottomLine">
                    <div class="des">
                        <div>
                            发起锁仓后需供应商同意，如果供应商同意您的锁仓请求，则48小时内您必须发起下单，且下单数量必须大于等于锁仓数量的10%（{{Math.ceil(lockTotal/10)}}件）；
                        </div>
                        <div>如48小时内，您未进行下单操作，则系统将强制按锁仓数量的10%（{{Math.ceil(lockTotal/10)}}件）进行下单。</div>
                    </div>
                    <div class="buttonBox">
                        <button class="cg-btn red" @click="closeLockSuccessModal">确定</button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="isloginTipShow" width="600">
            <div class="login-tip-box">
                <div class="img-none"></div>
                <div class="text">您尚未登录， 请先登录</div>
                <div class="btns">
                    <span class="btn1" @click="isloginTipShow = false">稍后登录</span>
                    <span class="btn2" @click="toLogin">立即登录</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getMallItemInfo,
        reserveOrder
    } from '../../../api/dealer'
    import {
        requestUserAddressList
    } from '../../../api/address'
    import {
        getTwoPointerNumber
    } from '../../../utils/tools.js'
    import {
        mapGetters
    } from 'vuex'
    // import addressall from '../setting/user-address.vue'
    export default {
        data() {
            return {
                isShowLockAddress: false,
                isShowLockSuccess: false,
                isShowLockList: false,
                isloginTipShow: false, // 登录提示弹框
                goodsImage: '',
                goodsImageList: [],
                detail: {
                    brand: '',
                    fabricAndAccessoryStr: '',
                    itemName: '',
                    itemState: '',
                    itemUnqueNumber: '',
                    item_fee_splitting: '',
                    item_id: '',
                    item_parent_id: '',
                    item_submit_time: '',
                    mallItemFileUrl: '',
                    price: '',
                    productCategory: '',
                    productContent: '',
                    sizeArr: '',
                    styleNumber: '',
                    totalStock: '',
                    user_id: '',
                },
                fabricAndAccessory: {
                    fabricName: '',
                    fabricStuffing: '',
                    fabricIngredient: ''
                },
                sizeColorGroup: {},
                sizeColorArr: [],
                sizeColorArr_lock: [], //锁仓弹窗里的尺码颜色信息
                lockTotal: 0, //锁仓总数
                lockAddressId: '', //锁仓选的地址
                lockAddressItem: {
                    address_contact_phone: "",
                },

            }
        },
        components: {
            // addressall
        },
        created() {
            console.log(this.$route)
            this.getMallItemInfo();
            // this.getFirstAddress()
        },
        computed: {
            ...mapGetters(['userId'])
        },
        methods: {
            getFirstAddress() {
                let _this = this
                requestUserAddressList({
                    userId: this.userId
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        let addressList = res.data
                        console.log(addressList)
                        if (addressList.length > 0) {
                            addressList.forEach(function(item, index) {
                                if (item.address_is_default == 'y') {
                                    _this.lockAddressItem = item
                                    _this.lockAddressId = item.address_id
                                    return false
                                }
                            })
                        }
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            choseLockAddress(item) {
                this.lockAddressId = item.address_id
                this.lockAddressItem = item
                this.isShowLockAddress = false
            },
            changeLockNumber() { //输入锁仓数量，input框
                let _this = this
                let total = 0
                this.sizeColorArr_lock.forEach(function(outerItem, outerIndex) {
                    outerItem.colorChoseTotal = 0
                    outerItem.sizeArr.forEach(function(innerItem, innerIndex) {
                        outerItem.colorChoseTotal += Number(innerItem.sizelockNumber)
                        total += Number(innerItem.sizelockNumber)
                    })
                })
                _this.lockTotal = total
            },
            closeLockSuccessModal() {
                this.isShowLockList = false
                this.isShowLockSuccess = false
            },
            submitLock() {
                let _this = this
                let sizeColorArrSubmit = JSON.parse(JSON.stringify(this.sizeColorArr_lock))
                sizeColorArrSubmit.forEach(function(outerItem, outerIndex) {
                    outerItem.sizeArr.forEach(function(innerItem, innerIndex) {
                        innerItem.number = innerItem.sizelockNumber
                    })
                })
                console.log(this.sizeColorArr_lock, 'this.sizeColorArr_lock')
                console.log(sizeColorArrSubmit, 'sizeColorArrSubmit')
                let arg = {
                    supplierUserId: _this.detail.user_id, //供应商id
                    dealerUserId: _this.userId, //销售商id,
                    reserveInfo: JSON.stringify({
                        group: sizeColorArrSubmit
                    }), //锁仓详情数据json文本,
                    orderReserveQuantity: _this.lockTotal, //下单总数量,
                    itemId: _this.detail.item_id, //商品id（也就是款号id）,
                    // addressId:_this.lockAddressId
                }
                console.log(arg)
                if (!arg.dealerUserId) {
                    this.$message.error('销售商用户ID未获取')
                } else if (!arg.supplierUserId) {
                    this.$message.error('供应商用户ID未获取')
                } else if (arg.dealerUserId == arg.supplierUserId) {
                    this.$message.error('这是您自己的商品，不能锁仓')
                } else if (!arg.itemId) {
                    this.$message.error('商品ID未获取')
                } else if (arg.orderReserveQuantity <= 0) {
                    this.$message.error('锁仓总数不能为0')
                } else {
                    reserveOrder(arg).then(res => {
                        console.log(res)
                        if (res.errorCode == 200) {
                            this.isShowLockList = false
                            this.isShowLockSuccess = true
                            this.$message.success("锁仓成功")
                        }
                    })
                }

            },
            toLock() {
                if (!this.userId) {
                    this.isloginTipShow = true
                    return
                }
                if (this.userId == this.detail.user_id) {
                    this.$message.error('这是您自己的商品，不能锁仓')
                } else {
                    this.isShowLockList = true
                }
            },
            toTakeOrder(id) {
                if (!this.userId) {
                    this.isloginTipShow = true
                    return
                }
                let _this = this
                if (this.userId == this.detail.user_id) {
                    this.$message.error('这是您自己的商品，不能下单')
                } else {
                    this.$router.push({
                        path: '/dealer/goods/takeOrder',
                        query: {
                            itemId: _this.detail.item_id,
                            itemSupplierId: _this.detail.user_id
                        }
                    });
                }
            },
            getMallItemInfo() {
                getMallItemInfo({
                    itemId: this.$route.query.id
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.detail = res.data[0]
                        try {
                            var percentStr = this.detail.item_fee_splitting
                            var percentArr = percentStr.split(",")
                            this.detail.dealerPercent = getTwoPointerNumber(percentArr[0] * 100)
                            this.detail.supplierPercent = getTwoPointerNumber(percentArr[1] * 100)
                        } catch (error) {
                            this.detail.dealerPercent = 0
                            this.detail.supplierPercent = 0
                        }

                        this.goodsImage = process.env.VUE_APP_IMG_PREV + res.data[0].mallItemFileUrl
                        this.goodsImageList.push(this.goodsImage)
                        try {
                            let fab = JSON.parse(res.data[0].fabricAndAccessoryStr)
                            this.fabricAndAccessory = {
                                fabricName: fab.fabricName || '--',
                                fabricStuffing: fab.fabricStuffing || '--',
                                fabricIngredient: fab.fabricIngredient_type == 1 ? fab.fabricIngredient_custom ||
                                    '--' : fab.fabricIngredient_seclet || '--'
                            }
                        } catch (error) {
                            console.log(error)
                            this.fabricAndAccessory = {
                                fabricName: '--',
                                fabricStuffing: '--',
                                fabricIngredient: '--'
                            }
                        }
                        try {
                            let group = JSON.parse(res.data[0].sizeArr)
                            let arr = group.group.map(item => {
                                return {
                                    ...item,
                                    count: item.sizeArr.reduce((total, item) => {
                                        return total + item.number
                                    }, 0)
                                }
                            })
                            this.sizeColorArr = arr || []
                            console.log(this.sizeColorArr, 'sizeColorArr')

                            this.sizeColorArr_lock = JSON.parse(JSON.stringify(this.sizeColorArr))
                            this.sizeColorArr_lock.forEach(function(outerItem, outerIndex) {
                                outerItem.colorStockTotal = outerItem.count
                                outerItem.colorChoseTotal = 0
                                outerItem.sizeArr.forEach(function(innerItem, innerIndex) {
                                    innerItem.sizeStockTotal = Number(innerItem.number) //即总数，不变的值
                                    innerItem.sizelockNumber = 0 //当前锁仓输入的数量
                                })
                            })
                        } catch (error) {
                            console.log(error)
                            this.sizeColorArr = []
                        }

                    } else {
                        this.$message.error(res.errorMsg || '获取详情数据异常')
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            // toEditStock() {
            //   this.$router.push('/dealer/stock/edit?id=' + this.$route.query.id)
            // },
            handleClick(row) {
                console.log(row);
            },
            indexMethod(index) {
                return index + 1;
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            toLogin() {
                this.isloginTipShow = false
                this.$router.push('/login?redirect=' + this.$route.fullPath)    
            },
        },
    }
</script>

<style lang="scss" scoped>
    .el-dialog__header {
        padding: 0;
    }

    .addressAllModalWrap {
        padding: 20px;
    }

    .page-wrapper {
        padding-bottom: 24px; 
        // background: #fff;
    }

    .header-handle {
        margin-top: 24px;
        padding: 20px 24px;
        height: 28px;
        background: #fff;

        .search-box {
            float: left;
        }

        .btns {
            float: right;
        }
    }

    .table-wrap {
        margin-top: 24px;
        background: #fff;
        padding: 20px 15px;
    }

    .tableBox {
        .tableHead {
            display: flex;
            background: #FAFAFA;
            padding: 14px 48px;
            border: 1px solid #E6E6E6;

            .left {
                flex: 1;
            }

            .right {
                flex: 1;
                text-align: right;
            }
        }

        .tableContent {
            border: 1px solid #E6E6E6;

            .line {
                padding: 24px;
                padding-left: 48px;

                span {
                    margin-right: 60px;
                }
            }
        }
    }

    .pinkBlock {
        padding-left: 20px;
    }

    // 一个商品
    .line .icon {
        width: 18px;
        height: auto;
    }

    .detailPanel {
        display: flex;
        background: #fff;
        box-shadow: 0px 1px 0px 0px rgba(239, 239, 239, 1);
        padding: 40px 24px;

        .leftArea {
            .mainImgBox {
                width: 265px;
                height: 265px;
                border: 1px solid #eee;
                margin-bottom: 16px;

                .img {
                    width: 100%;
                    height: 100%;
                }
            }

            .subImgBox {
                .imgBox {
                    width: 80px;
                    height: 80px;
                    border: #eee;
                    display: inline-block;
                    margin-right: 12px;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }

            }
        }

        .rightArea {
            padding-left: 32px;
            flex: 1;

            .title {
                color: #000000;
                font-size: 20px;
            }

            .normalLine {
                font-size: 12px;
                ;
                color: #999;
                margin: 16px 0;
                display: flex;

                .left {
                    width: 300px;
                }

                // .right{flex:1;}
            }
            .normalLine.firstLine{
                margin-top: 6px;
                margin-bottom: 6px;
            }
            .normalLine.secondLine{
                margin-top: 6px;
                margin-bottom: 20px;
            }

            .redArea {
                background: rgba(248, 29, 34, 0.03);
                padding: 16px 16px 24px;

                .priceLine {
                    font-size: 16px;
                    color: #666;
                    margin-bottom:10px;
                    ;

                    .num {
                        color: #FB1710;
                        font-size: 32px;
                        margin-bottom: 35px;
                        color: #FB1710;
                        .danwei{font-size:16px;font-style: normal;font-weight: 600;}
                    }
                }

                .fenyong {
                    font-size: 16px;
                    color: #666;
                }
            }

            .fenge {
                border: 0.5px solid #e6e6e6;
                margin: 25px 0;
            }

            .line {
                color: #999;
                margin: 20px 0;
            }
        }

        .mylabel {
            color: #999;
            font-size: 14px;
            margin-right: 20px;
        }

        .smallBtn {
            display: inline-block;
            padding: 4px 16px;
            font-size: 14px;
            color: #999999;
            border-radius: 4px;
            margin-right: 24px;
            border: 1px solid #aaa;
            opacity: 0.8;
        }

        .yellow {
            color: #FFA958
        }

        .oneSizeArr {
            display: inline-block;
            margin-right: 50px;
            vertical-align: top;
            // border:1px solid blue;

            .line {
                margin: 5px;
            }
            
            .sizeLine {
                padding-left:6px;
                // border:1px solid blue;
                margin: 10px 0;
                .size {
                }
                .sizeNum {
                }
            }
            
        }

        .sizeLine {
            padding-left: 10px;
            margin: 24px 0;
            font-size: 14px;
            color: #333;

            .size {
                display: inline-block;
                width: 50px;
            }

            .sizeNum {
                display: inline-block;
            }
        }
    }

    .buttonLine {
        padding-bottom: 16px;

        button {
            width: 160px;
            height: 40px;
        }
        .cg-btn{font-size: 16px;letter-spacing: 4px;}

        .leftBtn {
            margin-right: 64px;
        }
    }

    .panelBox {
        margin-top: 24px;
        // box-shadow:0px 3px 8px 0px rgba(220,220,220,1); 
        background: #fff;
        padding-bottom: 24px;

        .panelTitle {
            color: #000;
            font-size: 16px;
            font-weight: bold;
            padding: 40px 40px 24px;
        }

        .panelContent {
            color: #000;
            font-size: 14px;
            padding: 0 40px;

            .oneItem {
                display: inline-block;
                margin-right: 140px;

                .myLabel {
                    opacity: 0.85;
                }

                .text {
                    opacity: 0.65;
                }
            }
        }
    }

    .minFont {
        color: #999;
    }

    .cg-crumb {
        padding: 16px 0;
        font-size: 14px;
    }

    .sizeControlBlock {
        display: inline-block;
        width: 320px;
        margin: 24px 0;
        margin-right: 24px;
        border: 1px solid #e6e6e6;

        .sizeControl {
            padding: 0 16px;
            height: 36px;
            line-height: 36px;
            display: flex;
            border-bottom: 1px solid #e6e6e6;

            .left {}

            .right {
                flex: 1;
                text-align: right;
            }
        }


        .sizeContent {
            padding: 0 16px;

            // *{outline: 1px solid blue;}
            .sizeLine {
                display: flex;
                margin: 9px 0;
                vertical-align: bottom;
                line-height: 32px;

                .left {
                    width: 50px;
                    text-align: center;
                }

                .middle {}

                .right {
                    flex: 1;
                    text-align: right;
                }
            }
        }
    }

    .addressControl {
        border: 1px dotted #aaa;
        width: 660px;
        font-size: 14px;
        color: #000;
        opacity: 0.65;
        height: 40px;
        line-height: 40px;
        text-align: center;

        .plus {}
    }

    .bottomLine {
        margin: 29px 0;
        font-size: 20px;
        color: #333;

        .redSpan {
            color: #F81D22;
        }

        button {
            margin-left: 40px;
        }
    }

    .pinkWrap {
        padding-left: 24px;
    }

    .pinkArea {
        width: 1212px;
        padding-left: 24px;
        height: 76px;
        line-height: 76px;
        background: rgba(255, 169, 88, 0.03);
        font-size: 20px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);

        .text {}

        .red {
            color: #F81D22;
            margin-right: 10px;
        }
    }

    .modalContentWrap .pinkBlock {
        text-align: center;
        background: rgba(255, 169, 88, 0.1);
        padding: 20px 10px;

        .title {
            font-size:20px;
            font-weight: bold;
            margin-bottom: 10px;
            color:#333;
        }

        .subTitle {
            font-size: 12px;
            color: #999;
        }
        
    }

    .modalContentWrap .panelBox {
        box-shadow: 0 0 0 0;
        padding-top:0px;
    }
    .modalContentWrap .panelTitle{padding-bottom: 16px;padding-top:10px;}

    .modalContentWrap .bottomLine {
        text-align: center;
        color: #999;
        font-size: 12px;

        .des {
            margin-bottom: 24px;
        }

        button {
            width: 146px;
            margin-left: 0;
            ;
        }
    }
    .take-order-table {
      &.scroll {
          height: 50vh;
          overflow-y: auto;
          overflow-x: visible;
      }
      .table {
        border: 1px solid #E6E6E6;
        width: 100%;
        min-width: 400px;
        border-spacing: 0;
        border-collapse: collapse;
        font-size:14px;
        tr {
          height: 50px;
        }
        tr.th {
          background: #fafafa;
        }
        tr th {
          color:rgba(0,0,0,0.85);
          font-weight: normal;
        }
        td {
          border: 1px solid #E6E6E6;
          text-align: center;
          color:rgba(0,0,0,0.85);
        }
        &.min-400 {
            min-width: 400px;
        }
      }
      &.mgt-24 {
          margin-top: 24px;
      }
      &.clearing {
          margin-top: 24px;
      }
      &.clearing tr th {
        border: 1px solid #E6E6E6;
      }
      &.clearing tr th:last-child, &.clearing tr td:last-child{
        color: #F81D22;
      }
      
    }
    .oneTdCol{padding:5px 0;}

    .login-tip-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        .img-none {
            width: 240px;
            height: 126px;
            background: url(../../../assets/img_no_login.png) no-repeat;
            background-size: cover;
        }
        .text {
            font-size: 16px;
            color: #000000;
            line-height: 32px;
        }
        .btns {
            margin-top: 40px;
            padding-bottom: 40px;
            span {
                display: inline-block;
                text-align: center;
                margin: 0 20px;
                width: 116px;
                height: 32px;
                font-size: 14px;
                line-height: 32px;
                border-radius: 2px;
                border: 1px solid;
                cursor: pointer;
                &.btn1 {
                    color: #000000;
                    background-color: #FFFFFF;
                    border-color: rgba(0, 0, 0, 0.15);
                }
                &.btn2 {
                    color: #fff;
                    background-color: #F81D22;
                    border-color: #F81D22;
                }
            }
        }
    }
</style>
